import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const boxWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 1,
  width: '100%',
};

export const datePickerWrapper: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  minWidth: 'fit-content',
};
